module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-align-center-e6e9e3e4e4cafd92e7a657372ab6c703.png";